<div class="card">
  <div class="row">
    <div class="col">
      <div class="input-group" style="width:100%" >
        <div class="form-floating">
          <input id="GrundSelect" style="width:100%" class="form-control" [ngModel]="slection" (ngModelChange)="updateFormFields($event)"
                 [ngbTypeahead]="Items"
                 [inputFormatter]="formatter"
                 [resultFormatter]="formatter"
                 [selectOnExact]="true" />

          <label for="GrundSelect">Adress-Suche</label>
        </div>
        <button class="input-group-text bi bi-pen" (click)="toggleIsEdit()" type="button"></button>
      </div>
    </div>
      <div class="card-body">
        <div class="row">
          <div class="col">
            <div class="form-floating mb-3">
              <input type="text" class="form-control" id="Streat" [readonly]="!isEditable" [disabled]="!isEditable" [(ngModel)]="AddressIntern.strasse" (blur)="onInputBlur($event)">
              <label for="Streat">Straße</label>
            </div>
          </div>
          <div class="col-3">
            <div class="form-floating mb-3">
              <input type="text" class="form-control" id="Number" [readonly]="!isEditable" [disabled]="!isEditable" [(ngModel)]="AddressIntern.hausnummer" (blur)="onInputBlur($event)">
              <label for="Number">Hausnummer</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="form-floating mb-3">
              <input type="text" class="form-control" id="Zip" [readonly]="!isEditable" [disabled]="!isEditable" [(ngModel)]="AddressIntern.plz" (blur)="onInputBlur($event)">
              <label for="Zip">PLZ</label>
            </div>
          </div>
          <div class="col">
            <div class="form-floating mb-3">
              <input type="text" class="form-control" id="City" [readonly]="!isEditable" [disabled]="!isEditable" [(ngModel)]="AddressIntern.ort" (blur)="onInputBlur($event)">
              <label for="City">Ort</label>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
